(function () {
    var nav = document.querySelector('.sticky-left-sidebar.portal-landing__nav');
    if (!nav) return;

    var navItems = nav.querySelectorAll('.sidebar-nav__item');
    var placeholder = document.createElement('div');
    nav.parentNode.insertBefore(placeholder, nav.nextSibling);

    var navAbsTop = 0;
    var ticking = false;

    function getHeaderOffset() {
        var style = getComputedStyle(document.documentElement);
        return (parseFloat(style.getPropertyValue('--header-height')) || 0)
             + (parseFloat(style.getPropertyValue('--sticky-header-height')) || 0);
    }

    function getScrollOffset() {
        return getHeaderOffset() + nav.offsetHeight;
    }

    function getSections() {
        var out = [];
        for (var i = 0; i < navItems.length; i++) {
            var sel = navItems[i].getAttribute('data-target');
            var target = sel ? document.querySelector(sel) : null;
            if (target) out.push({ item: navItems[i], target: target });
        }
        return out;
    }

    function recalcNavTop() {
        if (!nav.classList.contains('fixed')) {
            navAbsTop = nav.getBoundingClientRect().top + window.scrollY;
        }
    }

    function updateSticky() {
        if (navAbsTop === 0) recalcNavTop();
        if (window.scrollY + getHeaderOffset() >= navAbsTop) {
            nav.classList.add('fixed');
            placeholder.style.height = nav.offsetHeight + 'px';
        } else {
            nav.classList.remove('fixed');
            placeholder.style.height = '0';
        }
    }

    function setActive(activeItem) {
        for (var i = 0; i < navItems.length; i++) {
            if (navItems[i] === activeItem) {
                navItems[i].classList.add('active');
                navItems[i].setAttribute('aria-selected', 'true');
            } else {
                navItems[i].classList.remove('active');
                navItems[i].setAttribute('aria-selected', 'false');
            }
        }
    }

    function updateActive() {
        var sections = getSections();
        if (!sections.length) return;
        var threshold = getScrollOffset() + 10;
        var active = sections[0].item;
        for (var i = 0; i < sections.length; i++) {
            var rect = sections[i].target.getBoundingClientRect();
            if (rect.top - threshold <= 0) active = sections[i].item;
        }
        setActive(active);
    }

    function update() {
        updateSticky();
        updateActive();
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
            update();
            ticking = false;
        });
    }

    function getDesiredOffset() {
        // Prefer the actual fixed-nav bottom when available — it already includes
        // whatever the AU sticky header has settled at. Fall back to the CSS-var math
        // for the cold-click case where the nav hasn't gone `fixed` yet.
        if (nav.classList.contains('fixed')) {
            return nav.getBoundingClientRect().bottom;
        }
        return getScrollOffset();
    }

    function scrollToSection(target) {
        // Two instant scrolls inside one frame pair. The first lands using the cold
        // pre-scroll measurements; that movement causes the nav to flip to `fixed`
        // and any AU sticky header to materialise, after which the second pass uses
        // the real nav bottom to snap precisely below it. Done with `auto` so the
        // user perceives a single jump — same pattern as fund-page jumpToSection.
        function jump() {
            var top = target.getBoundingClientRect().top + window.scrollY - getDesiredOffset();
            if (top < 0) top = 0;
            window.scrollTo({ top: top, behavior: 'auto' });
        }

        jump();
        requestAnimationFrame(function () {
            requestAnimationFrame(jump);
        });
    }

    for (var i = 0; i < navItems.length; i++) {
        (function (item) {
            item.addEventListener('click', function (e) {
                var sel = item.getAttribute('data-target');
                var target = sel ? document.querySelector(sel) : null;
                if (!target) return;
                e.preventDefault();
                setActive(item);
                scrollToSection(target);
            });
        })(navItems[i]);
    }

    function init() {
        recalcNavTop();
        update();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    window.addEventListener('load', init);

    window.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', function () {
        nav.classList.remove('fixed');
        placeholder.style.height = '0';
        recalcNavTop();
        update();
    }, { passive: true });
})();
